import type { Breadcrumb } from '@/shared/lib';

export const QUALITY_RECORDS_BREADCRUMB: Breadcrumb = {
  name: 'Registros da Qualidade',
  path: '/',
  clickable: true,
};

export const GENERATE_RECORD_BREADCRUMB: Breadcrumb = {
  name: 'Gerar Registro',
  path: '',
  clickable: false,
};

export const FILL_RECORD_BREADCRUMB: Breadcrumb = {
  name: 'Preencher',
  path: '',
  clickable: false,
};

export const EDIT_RECORD_BREADCRUMB: Breadcrumb = {
  name: 'Editar',
  path: '',
  clickable: false,
};

export const VIEW_RECORD_BREADCRUMB: Breadcrumb = {
  name: 'Visualizar',
  path: '',
  clickable: false,
};

export const FILL_LOGS_BREADCRUMB: Breadcrumb = {
  name: 'Logs de preenchimento',
  path: '',
  clickable: false,
};

export function matrixPagePath(prefix: string, returnFolderCode: string | null = null): string {
  return returnFolderCode
    ? `/revisao-da-matriz/${returnFolderCode}`
    : `/registros-da-qualidade/${prefix}`;
}

export function buildGenerateRecordTrail(
  prefix: string,
  title: string,
  last: Breadcrumb = GENERATE_RECORD_BREADCRUMB,
  returnFolderCode: string | null = null
): Breadcrumb[] {
  return [
    QUALITY_RECORDS_BREADCRUMB,
    { name: title, path: matrixPagePath(prefix, returnFolderCode), clickable: true },
    last,
  ];
}
